/* Yearpins inquiry-email attribution v2 — 2026-10-08.
 * Complete replacement. No analytics events, cart changes or order writes.
 * History: 90 fixed days. Visit: per-tab, 30-minute inactivity boundary.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root && root.document) api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var TTL = 90 * 86400000;
  var KEY = 'yp_email_attribution_v2';
  var LEGACY_KEY = 'yp_email_attribution_v1';
  var VISIT_KEY = 'yp_email_visit_v2';
  var IDLE = 30 * 60 * 1000;
  var STOREFRONTS = ['yearpins.com', 'www.yearpins.com'];
  var PIFY = 'https://form-builder-dn.pifyapp.com';
  var IDS = ['13223', '13261', '14281', '18717'];
  var POPUPS = { '14281': '/collections/custom-coins', '18717': '/collections/fiesta-medals' };
  var SELECTOR = 'form#ProductQuoteForm, form#ModalQuoteForm';
  var TITLES = {
    yp_first_source_medium: 'First Source / Medium',
    yp_latest_source_medium: 'Latest Source / Medium',
    yp_landing_page: 'Landing Page',
    yp_source_page: 'Source Page'
  };
  var social = {
    fb: ['facebook.com', 'fb.com', 'fb.me'], ins: ['instagram.com'],
    tk: ['tiktok.com'], ytb: ['youtube.com', 'youtu.be'],
    whatsapp: ['whatsapp.com', 'wa.me'],
    pinterest: ['pinterest.com', 'pinterest.co.uk', 'pinterest.ca', 'pinterest.com.au', 'pinterest.de', 'pinterest.fr', 'pinterest.jp', 'pin.it'],
    quora: ['quora.com'], bing: ['bing.com'],
    twitter: ['twitter.com', 'x.com', 't.co'], threads: ['threads.net', 'threads.com'],
    lt: ['linktr.ee'],
    chatgpt: ['chatgpt.com', 'chat.openai.com'], gemini: ['gemini.google.com', 'bard.google.com']
  };
  var aliases = { facebook: 'fb', fb: 'fb', instagram: 'ins', ig: 'ins', ins: 'ins',
    tiktok: 'tk', tk: 'tk', youtube: 'ytb', yt: 'ytb', ytb: 'ytb',
    google: 'google', gads: 'google', gsearch: 'google', gshopping: 'google',
    chatgpt: 'chatgpt', gemini: 'gemini', whatsapp: 'whatsapp', wa: 'whatsapp',
    pinterest: 'pinterest', pin: 'pinterest', quora: 'quora', bing: 'bing',
    twitter: 'twitter', x: 'twitter', threads: 'threads', lt: 'lt', linktree: 'lt' };
  var googles = ['google.com', 'google.co.uk', 'google.ca', 'google.com.au', 'google.de',
    'google.fr', 'google.co.jp', 'google.co.in', 'google.es', 'google.it', 'google.com.br',
    'google.com.mx', 'google.nl', 'google.com.hk', 'google.com.tw', 'google.co.nz',
    'google.com.sg', 'google.ie', 'google.co.za', 'google.ch', 'google.at'];
  var excluded = ['tagassistant.google.com', 'admin.shopify.com', 'checkout.shopify.com',
    'shop.app', 'paypal.com', 'stripe.com', 'form-builder-dn.pifyapp.com'];
  function suffix(host, base) { return host === base || host.endsWith('.' + base); }
  function parse(value) {
    try { var u = new URL(value); return /^https?:$/.test(u.protocol) ? u : null; }
    catch (_) { return null; }
  }
  function token(value) { return String(value || '').trim().toLowerCase().slice(0, 100); }
  function platform(value) {
    var v = token(value);
    if (aliases[v]) return aliases[v];
    for (var name in social) if (social[name].some(function (d) { return suffix(v, d); })) return name;
    return googles.some(function (d) { return suffix(v, d); }) ? 'google' : '';
  }
  function hit(source, medium) { return { source: source, medium: medium }; }
  function cleanPage(value) {
    var u = parse(value);
    return u ? u.origin + u.pathname : 'unknown';
  }
  function classify(href, referrer) {
    var u = parse(href), r = parse(referrer);
    if (!u) return null;
    // Internal navigation does not become a new acquisition, even with copied UTM parameters.
    if (r && suffix(r.hostname, 'yearpins.com')) return null;
    var q = u.searchParams, source = token(q.get('utm_source')), medium = token(q.get('utm_medium'));
    var p = platform(source);
    var paid = /^(cpc|ppc|paid|paid_social|paid_search|paid_shopping|display|cpm|cpv)$/.test(medium);
    if (['gclid', 'gbraid', 'wbraid'].some(function (k) { return !!q.get(k); }) ||
        (p === 'google' && (paid || source === 'gads'))) return hit('gads', 'paid');
    var sag = token(q.get('utm_campaign')) === 'sag_organic' || token(q.get('utm_content')) === 'sag_organic';
    if ((p === 'google' && sag) || (!source || p === 'google') && q.get('srsltid') ||
        source === 'gshopping' && /^(organic|organic_shopping|free_listing)$/.test(medium)) {
      return hit('gshopping', 'organic_shopping');
    }
    if (source) {
      // Explicit Shop storefront referral. Keep untagged shop.app/payment returns excluded.
      if (source === 'shop-website') return hit('shop', 'referral');
      // Store-defined shared Meta DM link: cannot distinguish Facebook, Instagram or WhatsApp.
      if (source === 'sm') return hit('sm', paid ? 'paid' : 'messaging');
      // Unknown UTM labels are not copied into emails: a URL parameter can contain personal data.
      if (!p) return hit('others', paid ? 'paid' : medium === 'email' ? 'email' : 'unknown');
      if (p === 'google') return /^(organic|organic_search)$/.test(medium) || source === 'gsearch'
        ? hit('gsearch', 'organic_search') : hit('others', 'unknown');
      if (p === 'chatgpt' || p === 'gemini') return hit(p, 'ai_referral');
      if (p === 'lt') return hit('lt', 'referral');
      if (p === 'pinterest' || p === 'quora' || p === 'twitter' || p === 'threads') return hit(p, 'organic_social');
      if (p === 'bing') return hit('bing', paid ? 'paid' :
        !medium || /^(organic|organic_search)$/.test(medium) ? 'organic_search' : 'referral');
      // Messaging is a custom email attribution label, not a GA4 channel definition.
      if (p === 'whatsapp') return hit(p, paid ? 'paid' : 'messaging');
      return hit(p, paid ? 'paid_social' : /^(social|organic_social|organic)$/.test(medium) ? 'organic_social' : 'unknown');
    }
    if (!r) return hit('direct', 'unknown');
    if (excluded.some(function (d) { return suffix(r.hostname, d); }) || suffix(r.hostname, 'myshopify.com')) return null;
    p = platform(r.hostname);
    if (!p) return hit('others (' + r.hostname + ')', 'referral');
    if (p === 'lt') return hit('lt', 'referral');
    if (p === 'google') return hit('gsearch', 'organic_search'); // Inference; untagged ads cannot be distinguished.
    if (p === 'bing') return hit('bing', 'organic_search'); // Referrer inference, not proof of ad spend.
    if (p === 'pinterest' || p === 'quora' || p === 'twitter' || p === 'threads') return hit(p, 'organic_social');
    if (p === 'whatsapp') return hit(p, 'referral'); // Referrer alone does not prove messaging or paid traffic.
    return hit(p, p === 'chatgpt' || p === 'gemini' ? 'ai_referral' : 'unknown');
  }
  function sourceOK(s) {
    return s && typeof s.source === 'string' && s.source.length <= 200 &&
      typeof s.medium === 'string' && s.medium.length <= 100;
  }
  function nonDirect(s) { return sourceOK(s) && !/^(direct|unknown)$/.test(s.source); }
  function sameSource(a, b) { return sourceOK(a) && sourceOK(b) && a.source === b.source && a.medium === b.medium; }
  function valid(s, now) {
    return s && s.v === 2 && Number.isFinite(s.created) && now >= s.created &&
      now - s.created < TTL && sourceOK(s.first) && (s.lastNonDirect === null || nonDirect(s.lastNonDirect));
  }
  function migrate(old, now) {
    if (!old || old.v !== 1 || !Number.isFinite(old.created) || now < old.created ||
        now - old.created >= TTL || !sourceOK(old.first) || !sourceOK(old.latest)) return null;
    // Never migrate old.landing: it is NOT the current visit's landing page.
    return { v: 2, created: old.created, first: old.first,
      lastNonDirect: nonDirect(old.latest) ? old.latest : nonDirect(old.first) ? old.first : null };
  }
  function history(previous, incoming, now) {
    var s = valid(previous, now) ? JSON.parse(JSON.stringify(previous)) :
      { v: 2, created: now, first: sourceOK(incoming) ? incoming : hit('unknown', 'unknown'), lastNonDirect: null };
    if (nonDirect(incoming)) s.lastNonDirect = incoming;
    return s;
  }
  function visitValid(v, now) {
    return v && v.v === 2 && Number.isFinite(v.lastActivity) && now >= v.lastActivity &&
      now - v.lastActivity < IDLE && sourceOK(v.source) && typeof v.landing === 'string' &&
      v.context && typeof v.context.page === 'string' && typeof v.context.guide === 'string';
  }
  function sitePage(url) {
    var u = parse(url);
    return u && STOREFRONTS.indexOf(u.hostname) >= 0 ? cleanPage(url) : '';
  }
  function startVisit(previous, href, referrer, now, navigationType) {
    var page = cleanPage(href), ref = sitePage(referrer), active = visitValid(previous, now);
    // A refresh must not reinterpret the original external referrer/UTM as another visit.
    var reload = navigationType === 'reload';
    var restored = reload || navigationType === 'back_forward';
    var incoming = restored ? (active ? null : hit('direct', 'unknown')) : classify(href, referrer);
    var v;
    if (active) v = JSON.parse(JSON.stringify(previous));
    else v = { v: 2, source: sourceOK(incoming) ? incoming : hit('unknown', 'unknown'),
      landing: ref && !previous && !restored ? 'unknown' : page, lastActivity: now, context: { page: page, guide: '' } };
    // An internal first observation cannot reveal the actual earlier landing page.
    var keep = active && previous.context.page === page &&
      (navigationType === 'reload' || ref === page || navigationType === 'back_forward');
    v.context = { page: page, guide: keep ? previous.context.guide : !restored && ref && ref !== page ? ref : '' };
    v.lastActivity = now;
    return { visit: v, incoming: incoming };
  }
  function resumeVisit(v, page, now) {
    if (visitValid(v, now)) {
      var copy = JSON.parse(JSON.stringify(v)); copy.lastActivity = now; return copy;
    }
    // Observed activity after idle, without a fresh navigation/acquisition.
    return { v: 2, source: hit('direct', 'unknown'), landing: cleanPage(page),
      lastActivity: now, context: { page: cleanPage(page), guide: '' } };
  }
  function latest(s, v) {
    if (!s || !v) return hit('unknown', 'unavailable');
    return nonDirect(s.lastNonDirect) && !sameSource(s.lastNonDirect, s.first) ? s.lastNonDirect : v.source;
  }
  function fields(s, v, page, kind) {
    function label(x) { return x.source + ' / ' + x.medium; }
    return {
      yp_first_source_medium: s ? label(s.first) : 'unknown / unavailable',
      yp_latest_source_medium: s && v ? label(latest(s, v)) : 'unknown / unavailable',
      yp_landing_page: v ? v.landing : 'unknown',
      yp_source_page: kind === 'pify' ? v && v.context ? v.context.guide : '' : cleanPage(page)
    };
  }
  function install(w) {
    if (w.YPSourceAttribution || w.top !== w.self || STOREFRONTS.indexOf(w.location.hostname) < 0) return;
    var d = w.document, memory = null, visit = null, captured = false, peers = new Map();
    var entry = w.location.href, referrer = d.referrer, nav = '';
    try { nav = (w.performance.getEntriesByType('navigation')[0] || {}).type || ''; } catch (_) {}
    function allowed() {
      try {
        var p = w.Shopify && w.Shopify.customerPrivacy;
        if (!p || typeof p.analyticsProcessingAllowed !== 'function' ||
            typeof p.marketingAllowed !== 'function') return null;
        var a = p.analyticsProcessingAllowed(), m = p.marketingAllowed();
        if (typeof a !== 'boolean' || typeof m !== 'boolean') return null;
        return a && m;
      } catch (_) { return null; }
    }
    function read(storage, key) { try { return JSON.parse(storage.getItem(key)); } catch (_) { return null; } }
    function save(storage, key, value) { try { storage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } }
    function drop(storage, key) { try { storage.removeItem(key); } catch (_) {} }
    function local() { try { return w.localStorage; } catch (_) { return null; } }
    function session() { try { return w.sessionStorage; } catch (_) { return null; } }
    function snapshot(touch) {
      var now = Date.now();
      var consent = allowed();
      if (consent !== true) {
        memory = null; visit = null; captured = false;
        // Unready API: do not read/write/expose history, but do not erase it.
        if (consent === false) {
          drop(local(), KEY); drop(local(), LEGACY_KEY); drop(session(), VISIT_KEY);
        }
        return false;
      }
      var stored = read(local(), KEY);
      if (valid(stored, now)) memory = stored;
      if (!captured) {
        if (!valid(memory, now)) memory = migrate(read(local(), LEGACY_KEY), now);
        var next = startVisit(read(session(), VISIT_KEY), entry, referrer, now, nav);
        visit = next.visit;
        memory = history(memory, next.incoming, now);
        captured = true;
      } else if (!valid(memory, now)) {
        // Expiry cannot turn an old stored acquisition into a new first acquisition.
        memory = history(null, hit('unknown', 'unknown'), now);
      }
      if (touch) visit = resumeVisit(visit, w.location.href, now);
      var persisted = save(local(), KEY, memory);
      save(session(), VISIT_KEY, visit);
      if (persisted) drop(local(), LEGACY_KEY);
      return true;
    }
    function inject(form, data) {
      if (!form || !form.matches || !form.matches(SELECTOR)) return;
      var action = parse(form.action);
      if (!action || action.origin !== w.location.origin || !/\/contact\/?$/.test(action.pathname)) return;
      snapshot(false);
      var values = fields(memory, visit, w.location.href, 'native');
      if (form.id === 'ModalQuoteForm') {
        var legacy = form.querySelector('input[name="contact[Source Page URL]"]');
        if (legacy) legacy.name = 'contact[Source Page]';
      }
      Object.keys(TITLES).forEach(function (key) {
        var name = 'contact[' + TITLES[key] + ']';
        var inputs = Array.from(form.querySelectorAll('input')).filter(function (el) { return el.name === name; });
        var input = inputs.shift();
        inputs.forEach(function (el) { el.remove(); });
        if (!input) { input = d.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
        input.value = values[key];
        if (data) data.set(name, values[key]);
      });
    }
    function expectedFrame(event, id) {
      if (event.origin !== PIFY) return false;
      return Array.from(d.querySelectorAll('iframe')).some(function (frame) {
        if (frame.contentWindow !== event.source) return false;
        var u = parse(frame.src);
        return !!(u && u.origin === PIFY && (u.pathname.split('/').includes(id) ||
          frame.id === 'pifyform-' + id || frame.closest('[id="pifyform-' + id + '"]')));
      });
    }
    function reply(target, id) {
      snapshot(false);
      // Only these user-confirmed same-page popups use the hosting collection.
      // Clone the context: do not change the original Contact Us / Get Quote guide.
      var responseVisit = visit;
      if (memory && visit && POPUPS[id] === w.location.pathname.replace(/\/$/, '')) {
        responseVisit = JSON.parse(JSON.stringify(visit));
        responseVisit.context = { page: cleanPage(w.location.href), guide: cleanPage(w.location.href) };
      }
      try {
        target.postMessage({ type: 'yp:attribution-values', formId: id, version: 2,
          values: fields(memory, responseVisit, w.location.href, 'pify'),
          context: memory && responseVisit ? { history: memory, visit: responseVisit, page: cleanPage(w.location.href) } : null
        }, PIFY);
      } catch (_) {}
    }
    function refresh() {
      snapshot(false);
      d.querySelectorAll(SELECTOR).forEach(function (form) { inject(form); });
      peers.forEach(function (id, target) { reply(target, id); });
    }
    w.addEventListener('message', function (event) {
      var msg = event.data;
      if (!msg || !['yp:attribution-request', 'yp:attribution-activity'].includes(msg.type) ||
          IDS.indexOf(msg.formId) < 0 || !expectedFrame(event, msg.formId)) return;
      peers.set(event.source, msg.formId);
      if (msg.type === 'yp:attribution-activity') snapshot(true);
      reply(event.source, msg.formId);
    });
    var lastTouch = 0;
    function activity(e) {
      if (e && e.isTrusted === false) return;
      var now = Date.now();
      if (now - lastTouch < 1000 && visitValid(visit, now)) return;
      lastTouch = now; snapshot(true); refresh();
    }
    ['pointerdown', 'keydown', 'input', 'scroll'].forEach(function (name) {
      d.addEventListener(name, activity, { capture: true, passive: true });
    });
    // Same-page quote popup launch differs from navigation into a form page.
    d.addEventListener('click', function (e) {
      if (e.isTrusted === false) return;
      var el = e.target && e.target.closest ? e.target.closest('a,button,[role="button"]') : null;
      if (!el || !/^get\s+(?:(?:a|free)\s+)?quote$/i.test((el.textContent || '').trim())) return;
      var href = el.getAttribute('href'), target = null;
      try { target = href ? new URL(href, w.location.href) : null; } catch (_) {}
      if (target && (target.origin !== w.location.origin || target.pathname !== w.location.pathname)) return;
      if (snapshot(true)) {
        visit.context = { page: cleanPage(w.location.href), guide: cleanPage(w.location.href) };
        save(session(), VISIT_KEY, visit); refresh();
      }
    }, true);
    d.addEventListener('submit', function (e) { snapshot(true); inject(e.target); refresh(); }, true);
    d.addEventListener('formdata', function (e) { snapshot(true); inject(e.target, e.formData); }, true);
    d.addEventListener('visitorConsentCollected', refresh);
    w.addEventListener('pageshow', function (e) { if (e.persisted) snapshot(true); refresh(); });
    w.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });
    // Requests/visibility/timers are not human activity; no artificial session extension.
    d.addEventListener('visibilitychange', refresh);
    w.YPSourceAttribution = {
      version: 'YP-EMAIL-v2-20261026-popups',
      getFields: function (kind) { snapshot(false); return fields(memory, visit, w.location.href, kind === 'pify' ? 'pify' : 'native'); },
      refresh: refresh
    };
    var attempts = 0, loading = false;
    function boot() {
      if (allowed() !== null) { refresh(); return; }
      if (w.Shopify && w.Shopify.loadFeatures && !loading) {
        loading = true;
        w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          loading = false; refresh();
        });
      }
      if (++attempts < 30) w.setTimeout(boot, 500);
    }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  }
  return { classify: classify, history: history, migrate: migrate, valid: valid, startVisit: startVisit,
    resumeVisit: resumeVisit, fields: fields, latest: latest, install: install, IDLE: IDLE, TTL: TTL };
});
